import React, { useEffect, useState } from "react";
import { FalkonAiService } from "../../services/FalkonAiService";
import StaticticsBarGraph from "./statitics.component";
import PieChart from "./circular.stats.component";
import { Autocomplete, TextField } from "@mui/material";


interface Iprops {

}


const AiAnalytics: React.FC = (Props: Iprops) => {

    const [suggestedRepliesMetrics, setSuggestedRepliesMetrics] = useState<{
        Period: string;
        AcceptancyRate: any;
        AcceptedSuggestions: any;
        RejectedSuggestions: any;
        TotalSuggestions: any;
    }[]>([{
        Period: "14 days",
        AcceptancyRate: "",
        AcceptedSuggestions: "",
        RejectedSuggestions: "",
        TotalSuggestions: ""
    }]);

    const [timeline, setTimeline] = useState<string>("14 days")


    useEffect(() => {
        FalkonAiService.getAcceptancyRateDetails().then((res) => {
            const Data = Object.entries(res.data).map(([period, values]: [string, any]) => ({
                Period: period.replace("_", " "),
                AcceptancyRate: values.acceptance_rate,
                AcceptedSuggestions: values.accepted,
                RejectedSuggestions: values.rejected,
                TotalSuggestions: values.suggestions_shown
            }));
            setSuggestedRepliesMetrics(Data)
        }).catch(() => {

        })
    }, [])

    const transformStats = (stats: {
        Period: string;
        AcceptancyRate: number;
        AcceptedSuggestions: number;
        RejectedSuggestions: number;
        TotalSuggestions: number;
    }) => {
        return [
            { id: `${stats.AcceptedSuggestions}`, label: "Accepted Suggestions", value: stats.AcceptedSuggestions, color: "#93C28A" },
            { id: `${stats.RejectedSuggestions}`, label: "Rejected Suggestions", value: stats.RejectedSuggestions, color: "#E9B5AB" },
        ]
    };


    return (
        <div className="d-flex flex-direction h-p-100 w-p-100">
            <div className="h-10 w-p-100 d-flex align-center ml-4">
                <Autocomplete
                    size="small"
                    className={"w-16"}
                    classes={{ input: ` color-text-field-font`, paper: "w-16" }}
                    options={["14 days", "30 days"]}
                    getOptionLabel={(option: any) => option}
                    onChange={(e, value) => { setTimeline(value) }}
                    value={timeline}
                    disableClearable
                    renderInput={(params) =>
                        <TextField
                            {...params}
                            placeholder="Page Name"
                            required
                            variant="outlined"
                            size='small'
                            onKeyDown={(e) => (e.preventDefault())}
                            inputProps={{ ...params.inputProps, readOnly: true }}
                            className=''

                            InputLabelProps={{
                                shrink: true,
                            }} />} />
            </div>
            <div className="h-22 w-p-100 d-flex align-center">
                <div className="h-p-90 flex-1 mx-4 d-flex flex-direction br-4 ai-analytics-box">
                    <div className="d-flex align-center p-3">

                        <div className="h4-regular">
                            Total Suggestions
                        </div>
                        <div className="w-space bg-color-ai-analytics-box-info-status color-primary-light px-2 br-2 ml-auto h6-medium h-3 d-flex align-center">
                            {timeline}
                        </div>

                    </div>
                    <div className="d-flex align-center h1-semibold px-3">
                        {suggestedRepliesMetrics.find(x => x.Period === timeline)?.TotalSuggestions}
                    </div>
                    <div className="d-flex align-center color-primary-inactive h5-medium px-3">
                        Generated Suggestions
                    </div>
                </div>
                <div className="h-p-90 flex-1 mr-4 d-flex flex-direction br-4 ai-analytics-box">
                    <div className="d-flex align-center p-3">

                        <div className="h4-regular">
                            Accepted
                        </div>
                        <div className="w-space bg-color-ai-analytics-box-info-status color-primary-light px-2 br-2 ml-auto h6-medium h-3 d-flex align-center">
                            {timeline}
                        </div>

                    </div>
                    <div className="d-flex align-center h1-semibold px-3">
                        {suggestedRepliesMetrics.find(x => x.Period === timeline)?.AcceptedSuggestions}
                    </div>
                    <div className="d-flex align-center color-primary-inactive h5-medium px-3">
                        Accepted Suggestion Replies
                    </div>
                </div>
                <div className="h-p-90 flex-1 mr-4 d-flex flex-direction br-4 ai-analytics-box">
                    <div className="d-flex align-center p-3">

                        <div className="h4-regular">
                            Rejected
                        </div>
                        <div className="w-space bg-color-ai-analytics-box-info-status color-primary-light px-2 br-2 ml-auto h6-medium h-3 d-flex align-center">
                            {timeline}
                        </div>

                    </div>
                    <div className="d-flex align-center h1-semibold px-3">
                        {suggestedRepliesMetrics.find(x => x.Period === timeline)?.RejectedSuggestions}
                    </div>
                    <div className="d-flex align-center color-primary-inactive h5-medium px-3">
                        Rejected Suggestion Replies
                    </div>
                </div>
                <div className="h-p-90 flex-1 mr-4 d-flex flex-direction br-4 ai-analytics-box">
                    <div className="d-flex align-center p-3">

                        <div className="h4-regular">
                            Acceptancy Rate
                        </div>
                        <div className="w-space bg-color-ai-analytics-box-info-status color-primary-light px-2 br-2 ml-auto h6-medium h-3 d-flex align-center">
                            {timeline}
                        </div>

                    </div>
                    <div className="d-flex align-center h1-semibold px-3">
                        {suggestedRepliesMetrics.find(x => x.Period === timeline)?.AcceptancyRate} %
                    </div>
                    <div className="d-flex align-center color-primary-inactive h5-medium px-3">
                        Accepted Suggestions Rate
                    </div>
                    {/* <div className="d-flex align-center color-ai-analytics-box-increased-text h5-medium px-3">
                        +12.5% from yesterday
                    </div> */}
                </div>
            </div>

            <div className="h-50 w-p-100 d-flex align-center mt-3">
                <div className="h-p-100 flex-1 mx-4 d-flex flex-direction br-4 ai-analytics-box">
                    <div className={`min-h-10 d-flex justify-center align-center w-space px-4`}>
                        <div className="h4-semibold mr-2">
                            Overall Suggestions
                        </div>
                        <div className='d-flex justify-center align-center ml-auto'>
                            <div className='d-flex justify-center align-center mr-2'>
                                <div className='accepted-suggestions mr-1'></div>
                                <div className='h6-medium w-space'>Accepted Suggestions</div>
                            </div>
                            <div className='d-flex justify-center align-center'>
                                <div className='rejected-suggestions mr-1'></div>
                                <div className='h6-medium w-space'>Rejected Suggestions</div>
                            </div>
                        </div>
                    </div>
                    <div className="w-p-100 flex-1 d-flex align-center justify-center">

                        <StaticticsBarGraph
                            Stacked={false}
                            Data={(suggestedRepliesMetrics).map(x => {
                                return {
                                    date: x.Period,
                                    OpenTickets: x.AcceptedSuggestions,
                                    ClosedTickets: x.RejectedSuggestions,
                                }
                            })}
                            Bottom_Color_Details_Hide={true}
                            Horizontal_Lines={true}
                            Hide_YAxisLine={true}
                            Hide_XAxisLine={true}
                            Bar_one={{ backgroundColor: "#93C28A", name: "Accepted Suggestions" }}
                            Bar_two={{ backgroundColor: "#E9B5AB", name: "Rejected Suggestions" }}
                        />
                    </div>
                </div>
                <div className="h-p-100 flex-1 mr-4 d-flex flex-direction br-4 ai-analytics-box">
                    <div className={`min-h-10 d-flex justify-center align-center w-space px-4`}>
                        <div className="w-space bg-color-ai-analytics-box-info-status color-primary-light px-2 br-2 ml-1 h6-medium h-3 d-flex align-center">
                            {timeline}
                        </div>
                        <div className='d-flex justify-center align-center ml-auto'>
                            <div className='d-flex justify-center align-center mr-2'>
                                <div className='accepted-suggestions mr-1'></div>
                                <div className='h6-medium w-space'>Accepted Suggestions</div>
                            </div>
                            <div className='d-flex justify-center align-center'>
                                <div className='rejected-suggestions mr-1'></div>
                                <div className='h6-medium w-space'>Rejected Suggestions</div>
                            </div>
                        </div>
                    </div>
                    <div className="w-p-100 flex-1 d-flex align-center justify-center">
                        <PieChart data={transformStats(suggestedRepliesMetrics.find(x => x.Period === timeline))} />
                    </div>
                </div>
            </div>
        </div>
    )


}

export default AiAnalytics;